/**
 * Checks for the bank account numbers schools type into payment settings.
 *
 * Every Nigerian bank account number (NUBAN) has exactly 10 digits. A wrong
 * length is the most common typo, and it only shows up later as a failed
 * payout, so it is caught next to the field instead.
 */
export const NUBAN_LENGTH = 10;

/** Removes the spaces people paste in from bank statements ("012 345 6789"). */
export function normaliseAccountNumber(value: string | null | undefined): string {
  return (value ?? '').replace(/\s+/g, '');
}

/**
 * Plain-English problem with an account number, or '' when it is fine.
 * An empty value is only a problem when the field is required.
 */
export function accountNumberProblem(
  value: string | null | undefined,
  options: { required?: boolean } = {},
): string {
  const digits = normaliseAccountNumber(value);
  if (!digits) return options.required ? 'Enter the account number.' : '';
  if (!/^\d+$/.test(digits)) return 'Use digits only — no letters, dashes or other symbols.';
  if (digits.length !== NUBAN_LENGTH) {
    return `Nigerian account numbers have ${NUBAN_LENGTH} digits — this one has ${digits.length}.`;
  }
  return '';
}
